/** Where a staged post lands, in the words each network uses. */
export function postPlacementLabel(platform: string | null | undefined, format: string | null | undefined): string {
  const kind = String(format || 'feed').toLowerCase();
  if (kind === 'reel') return 'Reel';
  if (kind === 'story') return 'Story';
  if (platform === 'instagram') return 'Grid post';
  if (platform === 'google_business') return 'Google post';
  return 'Feed post';
}
